import axios from "axios";
import { useEffect, useState } from "react";

const usePost = (id) => {
    const [post, setPost] = useState({});
    useEffect(() => {
        axios.get(`https://tripaide-server.onrender.com/posts/${id}`)
            .then(res => {
                setPost(res.data);
                //console.log(res.data);
            })
    }, [id]);
    return [post, setPost]
};

export default usePost;